<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Historiales de los clientes</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Clientes"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.usuario="{ item }">
                <span>{{
                    item.usuario.AgenteAdmin == null
                        ? item.usuario.name
                        : item.usuario.AgenteAdmin.nombre
                }}</span>
            </template>
            <template v-slot:item.fecha_alta="{ item }">
                <span>{{ item.fecha_alta }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ path: `/guardar-cliente?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            search: "",
            headers: [
                { text: "Usuario", value: "usuario", sortable: false },
                { text: "Campo", value: "nombre_campo", sortable: false },

                { text: "Anterior", value: "anterior", sortable: false },
                { text: "Nuevo", value: "nuevo", sortable: false },

                { text: "Fecha", value: "updated_at", sortable: false },
            ],

            Clientes: [],
        };
    },
    created() {
        this.getClientes(this.$route.query.id);
    },
    methods: {
        getClientes(id) {
            axios.get(`api/historial-cliente/${id}`).then(
                (res) => {
                    this.Clientes = res.data.cliente;
                    for (let i = 0; i < this.Clientes.length; i++) {
                        const element = this.Clientes[i];
                        element.created_at = new Date(
                            element.created_at
                        ).toLocaleDateString();
                    }
                },
                (err) => {
                    this.$custom_error("Error consultando el cliente");
                }
            );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
